const E_MAP_BOUNDS_CHANGED = 'map-bounds-changed';
const E_STORE_SELECTED = 'store-selected';
const E_STORE_UNSELECTED = 'store-unselected';
const E_PLACES_CHANGED = 'places-changed';
const E_PLACES_GEOLOCATED = 'places-geolocated';
const E_PLACES_CLEAR = 'places-clear';
const E_FORM_SUBMIT = 'form-submit';
const E_FORM_SUCCESS = 'form-success';
const E_FORM_ERROR = 'form-error';
const E_FORM_SENT = 'form-sent';

class GoogleMap extends HTMLElement {
  map; latitude; longitude; zoom; bounds;

  constructor() {
    super();
    this.latitude = Number(this.dataset.latitude) || 0;
    this.longitude = Number(this.dataset.longitude) || 0;
    this.zoom = parseInt(this.dataset.zoom) || 3;

    this.init();
  }

  init = () => {
    this.map = new google.maps.Map(this, {
      center: { lat: this.latitude, lng: this.longitude},
      mapTypeId: 'roadmap',
      zoom: this.zoom,
      streetViewControl: false,
      mapId: this.dataset.id
    });

    this.map.addListener('bounds_changed', () => {
      this.bounds = this.map.getBounds();
      this.dispatchEvent(new CustomEvent(E_MAP_BOUNDS_CHANGED, {detail: this.bounds}));
    });
  }

  clear  = () => { 
    const latitude = Number(this.dataset.latitude) || 0;
    const longitude = Number(this.dataset.longitude) || 0;
    const zoom = parseInt(this.dataset.zoom) || 3;
    this.center(latitude, longitude);
    this.setZoom(zoom);
  }

  center = (latitude, longitude) => {
    this.latitude = latitude;
    this.longitude = longitude;
    this.map.setCenter({ lat: latitude, lng: longitude });
  }

  setLocation = (location) => {
    this.map.setCenter(location);
  }

  setZoom = (zoom) => {
    this.zoom = zoom;
    this.map.setZoom(zoom);
  }
}
if (!customElements.get('google-map')) {
  customElements.define('google-map', GoogleMap);
}

class LocatorStore extends HTMLElement {
  latitude; longitude; marker; defaultMarker; selectedMarker;
  static classes = {
    hidden: 'd-none'
  }

  constructor() {
    super();
    this.init();
  }

  init = () => {
    this.latitude = Number(this.dataset.latitude) || 0;
    this.longitude = Number(this.dataset.longitude) || 0;

    this.defaultMarker = document.createElement('img');
    this.defaultMarker.src = this.dataset.marker;

    this.selectedMarker = document.createElement('img');
    this.selectedMarker.src = this.dataset.markerSelected;

    this.addEventListener('click', () => this.showInfo());
  }

  showInfo = () => {
    console.log('showInfo');
    //this.marker.content = this.selectedMarker;
    //this.marker.content.innerHTML = `<div class="card">CIAO</div>`;
    this.dispatchEvent(new CustomEvent(E_STORE_SELECTED, {detail: this}));
  }

  hideInfo = () => {
    this.marker.content = this.createPin();
  }

  setMarker = (map) => {
    this.marker = new google.maps.marker.AdvancedMarkerElement({
      position: {lat: this.latitude, lng: this.longitude},
      title: this.dataset.title,
      map: map,
      content: this.createPin()
    });
    this.marker.addListener('click', () => this.showInfo());
  }

  createPin = () => {
    const content = document.createElement("div");
    content.classList.add("property");
    const div = document.createElement('div');
    div.innerHTML = this.innerHTML;
    div.querySelectorAll('[data-bs-toggle="collapse"]').forEach(el => el.remove());
    content.innerHTML = `
        <div class="dropup-center dropup">
          <div data-bs-toggle="dropdown" aria-expanded="false">
            <img src="${this.dataset.marker}" width="40" height="40">
          </div>
          <locator-dropdown data-store="${this.dataset.id}" class="dropdown-menu px-2">
            ${div.innerHTML}
          </locator-dropdown>
        </div>
      `;
    return content;
  }

  isInBounds = (bounds) => {
    return bounds.contains(new google.maps.LatLng(this.latitude, this.longitude));
  }

  hide = () => {
    this.classList.add(LocatorStore.classes.hidden);
  }

  show = () => {
    this.classList.remove(LocatorStore.classes.hidden);
  }

  getDistance = () => {
    return this.querySelector('locator-store-distance').getDistance();
  }

}
if (!customElements.get('locator-store')) {
  customElements.define('locator-store', LocatorStore);
}

class LocatorStores extends HTMLElement {
  static classes = {
    hidden: 'd-none'
  }

  constructor() {
    super();
    this.init();
  }

  init = () => {
  }

  filterStores = (bounds) => {
    var stores = this.querySelectorAll('locator-store');
    stores = Array.from(stores).sort((a, b) => {
      const c = a.getDistance() - b.getDistance();
      return c;
    });
    stores.forEach(store => {
      this.appendChild(store);
      if(store.isInBounds(bounds)){
        store.show();
      } else {
        store.hide();
      }
    });
  }

  hide = () => {
    this.classList.add(LocatorStoreInfo.classes.hidden);
  }

  show = () => {
    this.classList.remove(LocatorStoreInfo.classes.hidden);
  }
}
if (!customElements.get('locator-stores')) {
  customElements.define('locator-stores', LocatorStores);
}

class StoreLocator extends HTMLElement {
  map; search; stores;

  constructor() {
    super();
    this.init();
  }

  init = () => {
    this.map = this.querySelector('google-map');
    this.search = this.querySelector('input-places');
    this.stores = this.querySelectorAll('locator-store');

    window.addEventListener(E_PLACES_GEOLOCATED, (e) => {
      this.centerMap(e.detail.coords.latitude, e.detail.coords.longitude);
    });
    this.search.addEventListener(E_PLACES_CHANGED, (e) => {
      this.locationMap(e.detail[0].geometry);
    });
    this.search.addEventListener(E_PLACES_CLEAR, (e) => {
      this.map.clear();
    });
    this.map.addEventListener(E_MAP_BOUNDS_CHANGED, (e) => {
      this.filterStores(e.detail);
    });
    this.setMarkers();
  }

  setMarkers = () => {
    this.stores.forEach(store => {
      store.setMarker(this.map.map);
      store.addEventListener(E_STORE_SELECTED, (e) => {
        this.centerMap(store.latitude, store.longitude);
        this.map.setZoom(13);
      });
    });
  }

  filterStores = (bounds) => {
    const c = this.querySelector('locator-stores');
    c.filterStores(bounds);
  }

  centerMap = (latitude, longitude) => {
    this.map.center(latitude, longitude);
  }

  locationMap = (geometry) => {
    if(geometry && geometry.location)
      this.map.setLocation(geometry.location);
    this.map.setZoom(10);
  }
}
if (!customElements.get('store-locator')) {
  customElements.define('store-locator', StoreLocator);
}

class ThemeForm extends HTMLElement {
  inputs; valid; buttons; loader; form;

  static selectors = {
    inputs: "input-text,input-select,input-area,input-checkbox,input-password",
    submit: '[data-submit]',
    serverErrors: 'form-errors',
    serverSuccess: 'form-success',
    loader: 'theme-loader'
  }
  
  constructor() {
    super();
    this.form = this.querySelector('form');
    this.inputs = this.querySelectorAll(ThemeForm.selectors.inputs);
    this.buttons = this.querySelectorAll(ThemeForm.selectors.submit);
    this.loader = this.querySelector(ThemeForm.selectors.loader);
    this.init();
  }

  init = () => {
    if(this.querySelector(ThemeForm.selectors.serverErrors) != undefined){
      this.dispatchEvent(new CustomEvent(E_FORM_ERROR, { detail: 'server-error' }));
    }
    if(this.querySelector(ThemeForm.selectors.serverSuccess) != undefined){
      this.dispatchEvent(new CustomEvent(E_FORM_SUCCESS, { detail: 'server-success' }));
    }
    this.buttons.forEach(button => {
      button.addEventListener("click", (event) => {
        this.handleSubmit(event);
      });
    });
  }

  handleSubmit = (e) => {
    this.validate();
    if(this.valid){
      this.showLoader();
      this.form.submit();
    }
  }

  validate = () => {
    let inputs = this.querySelectorAll(ThemeForm.selectors.inputs);
    this.valid = true;
    inputs.forEach(input => {
      const valid = input.validate() != Input.ISINVALID;
      this.valid = valid && this.valid;
    });
    return this.valid;
  }

  showLoader = () => {
    if(this.loader != undefined)
      this.loader.show();
  }

  hideLoader = () => {
    if(this.loader != undefined)
      this.loader.hide();
  }
}
if (!window.customElements.get("theme-form")) {
  window.customElements.define("theme-form", ThemeForm);
}

class Input extends HTMLElement {
  input; required; messages; message; valid; group; invalidFeedback; form;

  static ISVALID = 1;
  static ISINVALID = 2;
  static ISNORMAL = 3;
  static classes = {
    valid: "valid",
    invalid: "is-invalid",
    validated: "has-validation"
  }

  validators = {
    email: false,
    pattern: false,
    required: false,
    number: false,
    url: false,
    minLength: false,
    maxLength: false,
    equals: false,
    min: false,
    max: false,
    date: false,
    minDate: false,
    maxDate: false,
    minTime: false,
    maxTime: false
  };
  selectors = {
    input: "input",
    group: ".input-group",
    invalidFeedback: "[data-invalid]",
    validFeedback: "[data-valid]",
  };

  constructor() {
    super();
  }

  init = () => {
    this.form = this.closest('theme-form');
    this.valid = Input.ISNORMAL;
    this.input = this.querySelector(this.selectors.input);
    this.group = this.querySelector(this.selectors.group);
    this.invalidFeedback = this.querySelector(this.selectors.invalidFeedback);
    this.setEvents();
  }

  setEvents = () => { 
    this.getMessages();
    this.getValidators();

    this.input.addEventListener("blur", () => {
      this.validate();
    });

    this.input.addEventListener("focus", () => {
      this.setValid(true);
    });
  }

  getMessages = () => {
    this.messages = this.dataset.messages;
    if (this.messages == undefined) {
      this.messages = window.formErrors;
    } else {
      this.messages = JSON.parse(this.messages);
    }
  }

  getValidators = () => {
    for (let key in this.validators) {
      if (this.dataset[key] !== undefined) {
        this.validators[key] = this.dataset[key];
      }
      if(key === "email"){
        this.validators[key] = this.input.type == 'email';
      } else if(key === "url"){
        this.validators[key] = this.input.type == 'url';
      } else if(key === "number"){
        this.validators[key] = this.input.type == 'number';
      } else if(key === "date"){
        this.validators[key] = this.input.type == 'date' || this.input.type == 'datetime-local' || this.input.type == 'month' || this.input.type == 'week';
      } else if(key === 'required'){
        this.validators[key] = this.input.required;
      }
    }
  }

  validate = () => {
    this.valid = Input.ISVALID;
    for (let key in this.validators) {
      if (this.validators[key] !== false) {
        switch (key) {
          case "email":
            this.validateEmail();
            break;
          case "pattern":
            this.validatePattern();
            break;
          case "required":
            this.validateRequired();
            break;
          case "number":
            this.validateNumber();
            break;
          case "url":
            this.validateUrl();
            break;
          case "minLength":
            this.validateMinLength();
            break;
          case "maxLength":
            this.validateMaxLength();
            break;
          case "equals":
            this.validateEquals();
            break;
          case "min":
            this.validateMin();
            break;
          case "max":
            this.validateMax();
            break;
          case 'date':
            this.validateDate();
            break;
          case 'time':
            this.validateTime();
            break;
          case 'minDate':
            this.validateMinDate();
            break;
          case 'maxDate':
            this.validateMaxDate();
            break;
          case 'minTime':
            this.validateMinTime();
            break;
          case 'maxTime':
            this.validateMaxTime();
            break;
        }
        if (this.valid == Input.ISINVALID) {
          break;
        }
      }
    }
    if(this.valid == Input.ISVALID && this.isEmpty() && this.validators.required == false){
      this.valid = Input.ISNORMAL;
    }
    this.setValid();
    return this.valid;
  }

  setValid = (valid = null) => {
    if(valid !== null)
      this.valid = valid;
    
    if(this.group != undefined){
      this.group.classList.add(Input.classes.validated);
    }

    if(this.valid === Input.ISVALID) {
      if(this.group != undefined){
        this.group.classList.remove(Input.classes.invalid);
        this.group.classList.add(Input.classes.valid);
      }
      if(this.invalidFeedback != undefined){
        this.invalidFeedback.textContent = "";
      }
    }
    else if(this.valid === Input.ISINVALID){
      if(this.group != undefined){
        this.group.classList.remove(Input.classes.valid);
        this.group.classList.add(Input.classes.invalid);
      }
      if(this.invalidFeedback != undefined){
        this.invalidFeedback.textContent = this.message;
      }
    }
    else {
      if(this.group != undefined){
        this.group.classList.remove(Input.classes.invalid);
        this.group.classList.remove(Input.classes.valid);
      }
      if(this.invalidFeedback != undefined){
        this.invalidFeedback.textContent = "";
      }
    }

  }

  validateServer = (message) => {
    this.valid = Input.ISINVALID;
    this.message = message;
    this.setValid();
  }

  validateEmail = () => {
    if (this.validators.email !== false && !this.isEmpty()){
      let email = new RegExp("^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$");
      if (!email.test(this.input.value)) {
        this.valid = InputText.ISINVALID;
        this.message = this.messages.email;
      } 
    }
  }

  validatePattern = () => {
    if (this.validators.pattern !== false && !this.isEmpty()) {
      let pattern = new RegExp(this.dataset.pattern);
      if (!pattern.test(this.input.value)) {
        this.valid = Input.ISINVALID;
        this.message = this.messages.pattern;
      }
    }
  }

  validateRequired = () => {
    if (this.validators.required !== false) {
      if (this.isEmpty()) {
        this.valid = Input.ISINVALID;
        this.message = this.messages.required;
      }
    }
  }

  validateNumber = () => {
    if (this.validators.number !== false && !this.isEmpty()) {
      if (isNaN(this.input.value)) {
        this.valid = Input.ISINVALID;
        this.message = this.messages.number;
      }
    }
  }

  validateUrl = () => {
    if (this.validators.url !== false && !this.isEmpty()) {
      let url = new RegExp("^(http|https)://");
      if (!url.test(this.input.value)) {
        this.valid = Input.ISINVALID;
        this.message = this.messages.url;
      }
    }
  }

  validateMinLength = () => {
    if (this.validators.minLength !== false && !this.isEmpty()) {
      let minLength = parseInt(this.validators.minLength);
      if (this.input.value.length < minLength) {
        this.valid = Input.ISINVALID;
        this.message = this.messages.minLength.replace("{{ length }}", minLength);
      }
    }
  }

  validateMaxLength = () => {
    if (this.validators.maxLength !== false && !this.isEmpty()) {
      let maxLength = parseInt(this.validators.maxLength);
      if (this.input.value.length > maxLength) {
        this.valid = Input.ISINVALID;
        this.message = this.messages.maxLength.replace("{{ length }}", maxLength);
      }
    }
  }

  validateEquals = () => {
    if (this.validators.equals !== false && !this.isEmpty()) {
      let equals = document.querySelector(this.validators.equals);
      if (equals && this.input.value !== equals.value) {
        this.valid = Input.ISINVALID;
        this.message = this.messages.equals;
      }
    }
  }

  validateMin = () => {
    if (this.validators.min !== false && !this.isEmpty()) {
      let min = parseFloat(this.validators.min);
      if (isNaN(this.input.value) || parseFloat(this.input.value) < min) {
        this.valid = Input.ISINVALID;
        this.message = this.messages.min.replace("{{ min }}", min);
      }
    }
  }

  validateMax = () => {
    if (this.validators.max !== false && !this.isEmpty()) {
      let max = parseFloat(this.validators.max);
      if (isNaN(this.input.value) || parseFloat(this.input.value) > max) {
        this.valid = Input.ISINVALID;
        this.message = this.messages.max.replace("{{ max }}", max);
      }
    }
  }

  validateDate = () => {
    if (this.validators.date !== false && !this.isEmpty()) {
      let date = this.input.type == 'week' ? getDateOfWeek(this.input.value) : new Date(this.input.value);
      if (isNaN(date.getTime())) {
        this.valid = Input.ISINVALID;
        this.message = this.messages.date;
      }
    }
  }

  validateTime = () => {
    if (this.validators.time !== false && !this.isEmpty()) {
      let time = dateFromTime(this.input.value);
      if (isNaN(time.getTime())) {
        this.valid = Input.ISINVALID;
        this.message = this.messages.time;
      }
    }
  }

  validateMinDate = () => {
    if (this.validators.minDate !== false && !this.isEmpty()) {
      let minDate = new Date(this.validators.minDate);
      let date = new Date(this.input.value);
      if (date < minDate) {
        this.valid = Input.ISINVALID;
        this.message = this.messages.minDate.replace("{{ date }}", minDate.toLocaleDateString());
      }
    }
  }

  validateMaxDate = () => {
    if (this.validators.maxDate !== false && !this.isEmpty()) {
      let maxDate = new Date(this.validators.maxDate);
      let date = new Date(this.input.value);
      if (date > maxDate) {
        this.valid = Input.ISINVALID;
        this.message = this.messages.maxDate.replace("{{ date }}", maxDate.toLocaleDateString());
      }
    }
  }

  validateMinTime = () => {
    if (this.validators.minTime !== false && !this.isEmpty()) {
      let minTime = dateFromTime(this.validators.minTime);
      let time = dateFromTime(this.input.value);
      if (time.getTime() < minTime.getTime()) {
        this.valid = Input.ISINVALID;
        this.message = this.messages.minTime.replace("{{ time }}", minTime.toLocaleTimeString());
      }
    }
  }

  validateMaxTime = () => {
    if (this.validators.maxTime !== false && !this.isEmpty()) {
      let maxTime = dateFromTime(this.validators.maxTime);
      let time = dateFromTime(this.input.value);
      if (time.getTime() > maxTime.getTime()) {
        this.valid = Input.ISINVALID;
        this.message = this.messages.maxTime.replace("{{ time }}", maxTime.toLocaleTimeString());
      }
    }
  }

  isEmpty = () => {
    return this.input.value.trim() === "";
  }
}

class InputPlaces extends Input {
  search; 
  
  constructor() {
    super();
    this.selectors.input = "input";
    this.init();
  }

  setEvents = () => { 
    this.search = new google.maps.places.SearchBox(this.input);
    this.getMessages();
    this.getValidators();
    
    this.search.addListener('places_changed', () => {
      this.dispatchEvent(new CustomEvent(E_PLACES_CHANGED, { detail: this.search.getPlaces() }));
    });
    this.input.addEventListener('search', () => {
      if(this.input.value.length == 0){
        this.dispatchEvent(new CustomEvent(E_PLACES_CLEAR, { detail: this.search.getPlaces() }));
      }
    });
  }

  getPlaces = () => {
    return this.search.getPlaces();
  }

  setBounds = (bounds) => {
    this.search.setBounds(bounds);
  }
}
if (!window.customElements.get("input-places")) {
  window.customElements.define("input-places", InputPlaces);
}

class InputPlacesGeolocator extends HTMLElement {
  
  constructor() {
    super();
    this.init();
  }

  init = () => {
    this.addEventListener("click", () => {
      this.locate();
    });
  }

  locate = () => {    
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition((position) => {
        window.dispatchEvent(new CustomEvent(E_PLACES_GEOLOCATED, { detail: position }));
      });
    }
  }
}
if (!window.customElements.get("input-places-geolocator")) {
  window.customElements.define("input-places-geolocator", InputPlacesGeolocator);
}

dateFromTime = (timestr) => {
  var date = new Date();
  const time = timestr.split(" ").at(-1).split("T").at(-1);
  date.setHours(time.split(":")[0] || 0);
  date.setMinutes(time.split(":")[1] || 0);
  date.setSeconds(time.split(":")[2] || 0);
  return date;
}

getDateOfWeek = (wstr) => {
  const w = parseInt(wstr.split("W").at(-1));
  const y = parseInt(wstr.split("W").at(0));
  var d = (1 + (w - 1) * 7);
  return new Date(y, 0, d);
}

class LocatorStoreDistance extends HTMLElement {
  lat; lng; map; destination; distance;

  connectedCallback() {
    this.lat = Number(this.dataset.latitude) || 0;
    this.lng = Number(this.dataset.longitude) || 0;
    this.destination = new google.maps.LatLng(this.lat, this.lng); 
    this.checkDistance();
  }

  checkDistance = () => {
    try{
      this.distance = google.maps.geometry.spherical.computeDistanceBetween(new google.maps.LatLng(window.position.latitude, window.position.longitude), this.destination);
      const distanceInKm = (this.distance / 1000).toFixed(2);
      this.innerText = distanceInKm + ' km'; 
      return this.distance;
    } catch (e) {
      this.locate();
    }
  }

  getDistance = () => {
    const d = this.distance ? this.distance : this.checkDistance();
    return d;
  }

  locate = () => {    
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition((position) => {
        window.position = position.coords;
        this.checkDistance();
      });
    }
  }

}
if (!customElements.get('locator-store-distance')) {
  customElements.define('locator-store-distance', LocatorStoreDistance);
}

class LocatorStoreClose extends HTMLElement {

  connectedCallback() {
    this.init();
  }

  init = () => {
    document.querySelector('google-map').addEventListener(E_MAP_BOUNDS_CHANGED, () => this.toggle());
    this.addEventListener('click', this.close.bind(this));
  }

  // visualizza o nasconde la x quando lo store visualizzato è uno solo
  toggle = () => {
    const visibleStores = document.querySelectorAll('locator-store:not(.d-none)').length;
    if(visibleStores == 1){
      this.classList.add('d-block');
      this.classList.remove('d-none');
    } else {
      this.classList.remove('d-block');
      this.classList.add('d-none');
    }
  }

  // al click mette lo zoom della mappa iniziale
  close = (e) => {
    e.stopPropagation();
    const map = document.querySelector('google-map');
    map.clear();
    window.dispatchEvent(new CustomEvent(E_STORE_UNSELECTED));
  }

}
if (!customElements.get('locator-store-close')) {
  customElements.define('locator-store-close', LocatorStoreClose);
}

class LocatorDropdown extends HTMLElement {

  connectedCallback() {
    const store = document.querySelector(`locator-store[data-id="${this.dataset.store}"]`);
    store.addEventListener(E_STORE_SELECTED, this.show.bind(this));
    window.addEventListener(E_STORE_UNSELECTED, this.hide.bind(this));
  }

  show = (e) => {
    if(e){
      const bsDropdown = bootstrap.Dropdown.getOrCreateInstance(this);
      bsDropdown?.show();
    }
  }

  hide = (e) => {
    if(e){
      const bsDropdown = bootstrap.Dropdown.getOrCreateInstance(this);
      bsDropdown?.hide();
    }
  }

}
if (!customElements.get('locator-dropdown')) {
  customElements.define('locator-dropdown', LocatorDropdown);
}